// @flow
import React from "react";
import Toilets from "../../../svg/facilities/has_toilets.svg";

import "./toiletsIcon.scss";

const ToiletsIcon = () => <Toilets className="c-toilets-icon" />;

export default ToiletsIcon;
